import { siteConfig } from './siteConfig'

export const primaryLinks = [
  {
    de: { name: 'Agentur', to: '/agentur' },
    en: { name: 'agency', to: '/' + siteConfig.langs.en.key + '/agentur/' },
    imageSource: 'teamImage'
  },
  {
    de: { name: 'Expertise', to: '/expertise' },
    en: { name: 'services', to: '/' + siteConfig.langs.en.key + '/services/' },
    imageSource: 'servicesImage'
  },
  {
    de: { name: 'Cases', to: '/cases' },
    en: { name: 'cases', to: '/' + siteConfig.langs.en.key + '/cases/' },
    imageSource: 'casesImage'
  },
  {
    de: { name: 'Jobs', to: '/jobs' },
    en: { name: 'jobs', to: '/' + siteConfig.langs.en.key + '/jobs/' },
    imageSource: 'jobsImage'
    // badge: {
    //   text: 'React, Angular?',
    //   right: 16,
    //   bottom: -48,
    // },
  },
  {
    de: { name: 'Blog', to: '/blog' },
    en: { name: 'blog', to: '/' + siteConfig.langs.en.key + '/blog/' },
    counter: 17,
    imageSource: 'servicesImage'
  }
]

export const secondaryLinks = [
  {
    de: { name: 'Impressum', to: '/impressum' },
    en: { name: 'imprint', to: '/' + siteConfig.langs.en.key + '/impressum/' }
  },
  {
    de: { name: 'Datenschutz', to: '/datenschutz' },
    en: { name: 'data privacy', to: '/' + siteConfig.langs.en.key + '/datenschutz/' }
  }
  // {
  //   de: { name: 'Cookies 🍪', to: '/cookies' },
  //   en: { name: 'cookies 🍪', to: '/' + siteConfig.langs.en.key + '/cookies' }
  // }
]
